// extracted by mini-css-extract-plugin
export default {"content":"TambahBerita_content__ytYsL","main":"TambahBerita_main__kyGWT","form":"TambahBerita_form__j7ntF","preview":"TambahBerita_preview__IFpJ+"};